import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router"
import { Layout, Table, Input, Tooltip, Pagination } from "antd";
import { useLocation } from "react-router-dom";
import { Header, ContentEx as Content, FunctionTitle, CommonMessage, Footer, FooterButtonArea } from "../../core/CorePageContents";
import * as Module from "../../../modules/prime/mutual-aid/mutualAidModule";
import { CriteriaForm, Checkbox, AuthButton, MonthPicker, AuthButtonAuthorities } from "../../core/CoreForm";
import styles from "./MutualAidProjectList.module.css";
import { Store } from "antd/lib/form/interface";
import { initMessages, setMessages, message } from "../../../modules/core/commonMessageModule";
import { SortOrder } from "antd/lib/table/interface";
import * as Model from "../../../modules/prime/mutual-aid/mutualAidModel";
import { Moment } from "moment";
import * as CONSTANTS from "../../../constants/constants";
import * as messagesUtils from "../../../utils/messagesUtils";
import * as formatUtils from "../../../utils/formatUtils";
import * as Utils from '../../../utils/utils';
import { storedApiResult, initApiResult } from "../../../modules/core/bffApiModule";

interface titleInterface {
  title: string;
}

const EXIST_SUBMITED = "未承認あり"
const EXIST_APPROVED = "未申請あり"
const EXIST_REQUESTED = "申請済あり"
const EXIST_LINKED = "連携済あり"

export const MutualAidProjectList = (props: titleInterface) => {

  const dispatch = useDispatch();
  const apiResult = useSelector(storedApiResult);
  let dataList = useSelector(Module.storedDataList);
  let total = useSelector(Module.storedListTotal);
  let criteria = useSelector(Module.storedListCriteria);
  let resultCriteria = useSelector(Module.storedResultListCriteria);
  let history = useHistory();

  useEffect(() => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    dispatch(Module.getDataListAsync(criteria));
  },
    [criteria]
  );

  // ログインAPI終了後、API結果情報を初期化して、Now Loadingを継続することで、検索ボタンを押されないようにする。
  // (最初の検索でのキャッシュ作成前に再検索されてエラーにならないようにする)
  if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status
    && CONSTANTS.REQUEST_METHOD_GET === apiResult.requestMethod
    && CONSTANTS.URL_CMN_USERS_ === apiResult.url) {

    // API結果情報を初期化します。
    dispatch(initApiResult());
  }

  const moveToDetail = (record: Model.MutualAidProjectListRow) => {

    dispatch(Module.prepareMoveToDetail(record));
    dispatch(Module.prepareMoveToDetailCriteria(criteria));
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    history.push(CONSTANTS.PATH_PRIME_MUTUAL_AID_PROJECT_DETAIL);
  }

  // 画面遷移時のパラメータにメッセージが設定されている場合、そのメッセージを表示
  const location = useLocation<message>();
  if (location.state !== undefined) {
    const receivedMessage : message = {
      message: location.state.message
      , messageType: location.state.messageType
    }
    dispatch(setMessages([receivedMessage]));
  }

  /**
  * 一次協力会社名の一覧の整形
  * @param text
  * @param row
  */
  const renderfirstPartnerCompanyName = (text: string, row: Model.MutualAidProjectListRow) => {

    let firstPartnerCompanyNames: Array<any> = [];
    let promptTextList: Array<any> = [];

    let index = 0;
    row.firstPartnerCompanyList.forEach((partnerRow: Model.FirstPartnerCompanyRow) => {
      if (row.firstPartnerCompanyList.length >= 4 && index === 2) {
        // 一次協力会社が4つ以上ある場合、3件目以降は「...」で表示する
        firstPartnerCompanyNames.push(<div key={row.key + index} className={styles.columnAlignLeft}>...</div>);
      } else if (row.firstPartnerCompanyList.length < 4 || index < 3) {
        firstPartnerCompanyNames.push(
          <div key={row.key + index} className={styles.columnAlignLeft}>{partnerRow.firstPartnerCompanyName}</div>
        );
      }

      // Tooltipに表示するメッセージの作成
      promptTextList.push(<div>{partnerRow.firstPartnerCompanyName}</div>);
      index++;
    });

    if (row.firstPartnerCompanyList.length >= 4) {
      return {
        children: (<Tooltip placement="topLeft" title={promptTextList}><div>{firstPartnerCompanyNames}</div></Tooltip>)
      }
    } else {
      return {
        children: firstPartnerCompanyNames
      }
    }
  };

  const columns = [
    {
      title: "支店",
      key: "1",
      width: 250,
      dataIndex: "branchName",
      sortOrder: (criteria.sortItem !== "1") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidProjectListRow) => {
        return (
          <>
            <div className={styles.columnAlignLeft}>{text}</div>
          </>
        )
      },
    },
    {
      title: "プロジェクト",
      key: "2",
      width: 400,
      dataIndex: "projectName",
      sortOrder: (criteria.sortItem !== "2") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidProjectListRow) => {
        return (
          <>
            <div className={styles.columnAlignLeft}>{text}</div>
          </>
        )
      },
    },
    {
      title: "一次協力会社",
      key: "3",
      width: 250,
      sortOrder: (criteria.sortItem !== "3") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: renderfirstPartnerCompanyName
    },
    {
      title: "勤怠年月",
      key: "4",
      width: 100,
      sortOrder: (criteria.sortItem !== "4") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidProjectListRow) => {
        return (
          <>
            {<div >{formatUtils.formatMonthChar(row.attendanceYearMonth)}</div>}
          </>
        )
      }
    },
    {
      title: "工事区分",
      key: "5",
      width: 70,
      sortOrder: (criteria.sortItem !== "5") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidProjectListRow) => {
        return (
          <>
            {<div >{row.constructWorkType == "1" ? "公共" : row.constructWorkType ? "民間" : ""}</div>}
          </>
        )
      }
    },
    {
      title: "掛金申請状況",
      width: 300,
      showSorterTooltip: false,
      children: [{
        title: "未承認",
        width: 100,
        dataIndex: "submitted",
        align: "center" as "center",
        render: (test: string, row: Model.MutualAidProjectListRow) => {
          return (
            {
              props: {
                className: row.submitted > 0 ? styles.existSubmitOrConfirmed : {},
              },
              children: (<div>{test}</div>)
            }
          )
        }
      },
      {
        title: "未申請",
        width: 100,
        align: "center" as "center",
        dataIndex: "approved",
        render: (test: string, row: Model.MutualAidProjectListRow) => {
          return (
            {
              props: {
                className: row.approved > 0 ? styles.existSubmitOrConfirmed : {},
              },
              children: (<div>{test}</div>)
            }
          )
        }
      },
      {
        title: "申請済",
        width: 100,
        align: "center" as "center",
        dataIndex: "requested",
      },
      {
        title: "連携済",
        width: 100,
        align: "center" as "center",
        dataIndex: "linked",
      }]
    },
  ];

  const criteriaDataTransfer = (keyValueList: Array<{ key: string, value: any }>) => {
    let newCriteria: Model.MutualAidProjectListCriteria = {
      branchName: criteria.branchName,
      projectName: criteria.projectName,
      firstPartnerCompanyName: criteria.firstPartnerCompanyName,
      firstPartnerCompanyNameKana: criteria.firstPartnerCompanyNameKana,
      fromYYYYMM: criteria.fromYYYYMM,
      toYYYYMM: criteria.toYYYYMM,
      submitted: criteria.submitted,
      approved: criteria.approved,
      requested: criteria.requested,
      linked: criteria.linked,
      sortItem: criteria.sortItem,
      sortOrder: criteria.sortOrder,
      offset: criteria.offset,
      limit: criteria.limit,
    }
    keyValueList.forEach((rec: { key: string, value: any }) => {
      newCriteria[rec.key] = rec.value;
    })
    dispatch(Module.setListCriteria(newCriteria));
  }

  // 検索が正常終了した時の処理
  if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status
    && "" === apiResult.errorCode
    && CONSTANTS.REQUEST_METHOD_GET === apiResult.requestMethod
    && CONSTANTS.URL_MUTUAL_AID_PRIME_LIST === apiResult.url) {

    // 2ページ目以降を表示していて、総件数はあるが、表示するデータが空の場合、再取得する
    if (criteria.offset > 0 && total > 0 && (dataList.length === 0 || dataList[0].key === '')) {

      // API結果情報を初期化します。
      dispatch(initApiResult());

      // 最終ページを取得する（基本的には一つ前のページ）
      const newOffset = Utils.calcLastPageOffset(total, criteria.limit);
      criteriaDataTransfer([
        { key: "offset", value: newOffset }
      ]);
    }
  }


  //　連携結果画面へアクション
  const moveToOutputResult = () => {
    dispatch(Module.prepareMoveToResultListCriteria(resultCriteria));
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    // 登録画面へ遷移します。
    history.push(CONSTANTS.PATH_PRIME_MUTUAL_AID_RESULT);
  }

  // 検索ボタン押下時アクション
  const pushSerchButton = (value: Store) => {

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    criteriaDataTransfer([
        { key: "branchName", value: value.branchName }
      , { key: "projectName", value: value.projectName }
      , { key: "firstPartnerCompanyName", value: value.firstPartnerCompanyName }
      , { key: "firstPartnerCompanyNameKana", value: value.firstPartnerCompanyNameKana }
      , { key: "fromYYYYMM", value: value.fromYYYYMM === null ? "" : formatUtils.formatMonthNonSlash(value.fromYYYYMM) }
      , { key: "toYYYYMM", value: value.toYYYYMM === null ? "" : formatUtils.formatMonthNonSlash(value.toYYYYMM) }
      , { key: "submitted", value: value.submitted === true ? "1" : "0" }
      , { key: "approved", value: value.approved === true ? "1" : "0" }
      , { key: "requested", value: value.requested === true ? "1" : "0" }
      , { key: "linked", value: value.linked === true ? "1" : "0" }
      , { key: "offset", value: 0 }
    ]);
  }

  // Fromの日付を計算
  const setFromDate = () => {
    if (criteria.fromYYYYMM === "") {
      return null;
    }

    return formatUtils.getMonthMomentOf(formatUtils.formatMonthSlash(criteria.fromYYYYMM));
  }

  // toの日付を計算
  const setToDate = () => {
    if (criteria.toYYYYMM === "") {
      return null;
    }

    return formatUtils.getMonthMomentOf(formatUtils.formatMonthSlash(criteria.toYYYYMM));
  }

  // 検索フォーム
  const MutualAidProjectCriteria = () => {
    return (
      <CriteriaForm
        layout="inline"
        onFinish={pushSerchButton}
        initialValues={{
          "branchName": criteria.branchName
          , "projectName": criteria.projectName
          , "firstPartnerCompanyName": criteria.firstPartnerCompanyName
          , "firstPartnerCompanyNameKana": criteria.firstPartnerCompanyNameKana
          , "fromYYYYMM": setFromDate()
          , "toYYYYMM": setToDate()
          , "submitted": criteria.submitted === "1" ? true : false
          , "approved": criteria.approved === "1" ? true : false
          , "requested": criteria.requested === "1" ? true : false
          , "linked": criteria.linked === "1" ? true : false
        }}
      >
        <div className={styles.criteriaSearchFieldRight}>
          <CriteriaForm.Item name="branchName">
            <Input type="text"
              placeholder="支店名"
              maxLength={CONSTANTS.BRANCH_NAME_MAX_LENGTH}
              style={{ width: "140px" }} />
          </CriteriaForm.Item>
          <CriteriaForm.Item name="projectName">
            <Input type="text"
              placeholder="プロジェクト名"
              maxLength={CONSTANTS.PROJECT_NAME_MAX_LENGTH}
              style={{ width: "140px" }} />
          </CriteriaForm.Item>
          <CriteriaForm.Item name="firstPartnerCompanyName">
            <Input type="text"
              placeholder="一次協力会社名"
              maxLength={CONSTANTS.COMPANY_NAME_MAX_LENGTH}
              style={{ width: "140px" }} />
          </CriteriaForm.Item>
          <CriteriaForm.Item name="firstPartnerCompanyNameKana">
            <Input type="text"
              placeholder="一次協力会社名カナ"
              maxLength={CONSTANTS.COMPANY_NAME_MAX_LENGTH}
              style={{ width: "140px" }} />
          </CriteriaForm.Item>
          <div className={styles.duration}>
            <div >
              <CriteriaForm.Item name="fromYYYYMM"
                rules={[
                  ({ getFieldValue, validateFields }) => ({
                    validator(rule, value) {
                      if (getFieldValue("toYYYYMM") != null) {
                        validateFields(["toYYYYMM"]);
                      }
                      return Promise.resolve();
                    }
                  })
                ]}
                >
                <MonthPicker placeholder="勤怠年月(From)" format="YYYY/MM"
                  style={{ width: "140px" }} />
              </CriteriaForm.Item>
              <div className={styles.durationSpan}>～</div>
              <CriteriaForm.Item name="toYYYYMM"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (value == null || getFieldValue("fromYYYYMM") == null) {
                        return Promise.resolve();
                      }
                      if (getFieldValue("fromYYYYMM").isAfter(value, 'month')) {
                        return Promise.reject(messagesUtils.getMessage("ERROR_FROM_TO_DATE_RANGE", ["勤怠年月(From)", "勤怠年月(To)"]));
                      }

                      // To - From が半年以内でなければエラー
                      if ((value as Moment).diff(getFieldValue("fromYYYYMM").startOf("month"), "month") > 5) {
                        return Promise.reject(messagesUtils.getMessage("ERROR_FROM_TO_DATE_PERIOD"));
                      }
                      return Promise.resolve();
                    }
                  })
                ]}
                >
                <MonthPicker placeholder="勤怠年月(To)" format="YYYY/MM"
                  style={{ width: "140px" }} />
              </CriteriaForm.Item>
            </div>
            <div className={styles.calendarAnnotation}>※未入力の場合、今月と前月の2ヵ月分の検索となります</div>
          </div>

          <div className={styles.statusWorkTimeGrid}>
            <div className={`${styles.statusWorkTimeTopLeft} ${styles.statusWorkTimeLeft}`}>
              <span>建退共連携ステータス：</span>
            </div>
            <div className={`${styles.statusWorkTimeTopRight} ${styles.statusWorkTimeRight}`}>
              <CriteriaForm.Item name="submitted" valuePropName="checked">
                <Checkbox>
                  {EXIST_SUBMITED}
                </Checkbox>
              </CriteriaForm.Item>
              <CriteriaForm.Item name="approved" valuePropName="checked">
                <Checkbox>
                  {EXIST_APPROVED}
                </Checkbox>
              </CriteriaForm.Item>
              <CriteriaForm.Item name="requested" valuePropName="checked">
                <Checkbox>
                  {EXIST_REQUESTED}
                </Checkbox>
              </CriteriaForm.Item>
              <CriteriaForm.Item name="linked" valuePropName="checked">
                <Checkbox>
                  {EXIST_LINKED}
                </Checkbox>
              </CriteriaForm.Item>
            </div>
          </div>
          <AuthButton
            name={"検索"}
            shape={"round"}
            htmlType="submit"
          />

        </div>
      </CriteriaForm>
    )
  }

  /**
   * テーブル検索条件変更時イベント（ソート）
   * @param sorter
   */
  const handleTableChange = (sorter: any) => {

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let order = "";
    if (sorter.order === "ascend") {
      order = "0";
    } else if (sorter.order === "descend") {
      order = "1";
    }
    let sortItem = sorter.columnKey
    if (typeof sorter.column === "undefined") {
      sortItem = "";
    }

    criteriaDataTransfer([
      { key: "sortItem", value: sortItem }
      , { key: "sortOrder", value: order }
      , { key: "limit", value: criteria.limit }
      , { key: "offset", value: 0 } // ソート切替時は1ページ目から表示
    ])
  }

  /**
   * ページ変更時イベント（ページ、表示件数）
   * @param pagination
   * @param filters
   */
  const handlePaginationChange = (page: any, pageSize: any) => {

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let offsetReset: boolean = false;
    if (criteria.limit !== pageSize) {
      offsetReset = true;
    }

    criteriaDataTransfer([
      { key: "sortItem", value: criteria.sortItem }
      , { key: "sortOrder", value: criteria.sortOrder }
      , { key: "limit", value: pageSize }
      , { key: "offset", value: offsetReset ? 0 : (page - 1) * pageSize }
    ])
  }

  // フッターボタンエリアを描画します。
  const ButtonArea = () => {
    return (
      <FooterButtonArea>
        <AuthButton
          name={"連携結果"}
          authorities={[
            AuthButtonAuthorities.primeSystemMngAuth
          ]}
          size={"large"}
          shape={"round"}
          onClick={moveToOutputResult}
        />
      </FooterButtonArea>
    )
  }

  return (
    <Layout>
      <Header />
      <Content>
        <FunctionTitle title={props.title} />
        <MutualAidProjectCriteria />
        <CommonMessage searchNoDataName="プロジェクト" />
        {
          total > 0 && dataList.length > 0 && dataList[0].key !== '' ?
          <>
            <div className={"topPagination"}>
              <Pagination
                className={"commonPagination topLeftPagination"}
                defaultPageSize={10}
                pageSize={criteria.limit}
                pageSizeOptions={["5", "10", "20", "50", "100"]}
                showSizeChanger={true}
                showTotal={() => (<span>１ページあたりの表示件数</span>)}
                locale={{ items_per_page: "件/ページ" }}
                onChange={handlePaginationChange}
                onShowSizeChange={(page, size) => {
                  handlePaginationChange(page, size); // ページサイズ変更時に1ページ目へ戻す
                }}
              />
              <Pagination
                className={"commonPagination topRightPagination"}
                total={total}
                current={criteria.offset / criteria.limit + 1}
                pageSize={criteria.limit}
                showTotal={(total) => <><span>{total.toLocaleString()}</span> 件数中、<span>{(criteria.offset + 1).toLocaleString()}</span> － <span>{total <= criteria.offset + criteria.limit ? total.toLocaleString() : (criteria.offset + criteria.limit).toLocaleString()}</span> 件</>}
                onChange={handlePaginationChange}
              />
            </div>
            <Table
              size="small"
              scroll={{ x: 1000 }}
              sticky={{ offsetHeader : -31 }}
              columns={columns}
              dataSource={dataList}
              pagination={false}
              onChange={(pagination, filters, sorter) => handleTableChange(sorter)}
              onRow={(record, rowIndex) => {
                return {
                  onClick: () => {
                    moveToDetail(record)
                  }
                };
              }
              }
            >
            </Table>
            <Pagination
              className={"commonPagination bottomPagination"}
              total={total}
              current={criteria.offset / criteria.limit + 1}
              pageSize={criteria.limit}
              onChange={handlePaginationChange}
            />
          </>
          : <></>
        }
      </Content>
      <ButtonArea />
      <Footer />
    </Layout>
  );
}
